import styled from "styled-components";


export const Container = styled.div`
    display:flex;
    flex-direction: column;
    height: 600px;
    @media (min-width: 720px) {
        flex-direction: row;
        gap: 50px;
    }
`;

export const Graph = styled.div`
    flex: 1;
    min-height: 0;
    display: flex;
`;

export const ResponsivePie = styled.div`
    width: 100%;
    height: 100%;
`;


export const ButtonsStatusContainer = styled.div`
    position: absolute;
    display: flex;
    flex-direction: column;
    gap: 10px;
    
`;

export const ButtonStatus = styled.button`
    background: transparent;
    border: none;
    color: ${(props)=> props.color};
    cursor: pointer;
    font-size: 32px;  
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    outline: none;
    text-align: center;
    z-index: 10;
    @media (min-width: 720px) {
        font-size: 48px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        font-size: 32px;
    }
`;

export const ContainerSection = styled.div`
    display: flex;
    flex-direction: column;
    gap:12px;
`;

export const Section = styled.div`
    background: #006560;
    height: 46px;
    width: 310px;
    border-radius: 5px;
    padding: 16px 10px;
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

export const Title = styled.h3`
    font-size: 20px;
    font-weight: 700;
    color: #FFFFFF;
`;

export const Itens = styled.div`

    // height: 46px;
    padding-left: 10px;
    padding-right: 10px;
    width: 310px;
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

`;

export const Item = styled.div`
    font-size: 18px;
    font-weight: 600;
    color: #333333;
`;

export const ModalContent = styled.div`
  background: #F6F6F6;
  border-radius: 10px;
  padding: 20px 24px;
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 464px;
  overflow-y: auto;
`;

export const ConteinerLegend = styled.div`
    width: 150px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    text-align: right
`;


export const ContentLegend = styled.div`
    margin-bottom: 16px;
    display: flex;
    flex-direction: column;
`;


export const Legend = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const Label = styled.span`
    font-size: 14px;
    font-weight: 600;
    color: #333333;
`;

export const Circle = styled.span`
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: ${(props) => props.$color};
    flex-shrink: 0
`;

export const Underlined = styled.div`
  width: 100%;
  height: 4px;
  border-radius: 2px;
  background-color: ${(props) => props.$color};
  margin: 2px 0;
`;


export const Value = styled.div`
    font-size: 14px;
    font-weight: 800;
    color: ${(props) => props.$color};
    text-align: "right"
`;

